"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function Spinner({ size = 'lg' }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('animate-spin', {
            'w-2 h-2': size === 'xxs',
            'w-4 h-4': size === 'xs',
            'w-6 h-6': size === 'sm',
            'w-12 h-12': size === 'md',
            'w-16 h-16': size === 'lg',
            'w-[90px] h-[90px]': size === 'xl'
        }) }, { children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('border-blue-80', 'border-b-0', 'w-full', 'h-2/4', 'rounded-t-full', {
                'border-[10px]': size === 'lg' || size === 'xl',
                'border-[8px]': size === 'md',
                'border-[4px]': size === 'sm',
                'border-[2px]': size === 'xs',
                'border-[1px]': size === 'xxs'
            }) }) })));
}
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map